import { render, staticRenderFns } from "./CommissionList.vue?vue&type=template&id=74a15d06&scoped=true&lang=pug"
import script from "./CommissionList.vue?vue&type=script&lang=js"
export * from "./CommissionList.vue?vue&type=script&lang=js"
import style0 from "./CommissionList.vue?vue&type=style&index=0&id=74a15d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a15d06",
  null
  
)

export default component.exports